import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type { IPlanKindsResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IPlanKindsResponse>>,
  IPathBaseParam,
  IPaginationParams
>("planKinds");

export const planKinds = {
  ...getAllApis,
};
